import {useState, useEffect, useContext} from "react";
// import { useNavigate } from "react-router";
import {useNavigate, Link} from "react-router-dom";
import "./ShopWidget.scss";
import close from "../../Assets/images/close-circle.svg";
import {SaleContext, SetSaleContext} from "../pages/Pages";
import {formatToPersianAddComma} from "../../Utils/CommaSeparator";
import {toast} from "react-toastify";
import axios from "axios";
import {prefixUrl} from "../../Utils/utilsData";

const ShopWidget = (props) => {

  const setSaleNum = useContext(SetSaleContext);
  const SaleNum = useContext(SaleContext);
  const [shopItems, setShopItems] = useState([]);
  const [mainPrice, setMainPrice] = useState("");
  const navigateTo = useNavigate();
  const calculate = (items) => {
    let sum = 0;
    items.length === 0 && setMainPrice(0);
    for (let item of items) {
      sum += +item.count * (+item.mainPrice - +item.offerPrice);
      setMainPrice(sum.toString());
    }
  };
  const shopStorage = localStorage.getItem("products");
  useEffect(() => {
    const items = localStorage.getItem("products") === "" ? []
      : JSON.parse(localStorage.getItem("products"));
    // if (items?.length > 0) {
    //   calculate(items);
    //   debugger;

    // }
    calculate(items);
    setShopItems(items);
  }, [SaleNum, shopStorage]);

  const handleAddToCart = (item, action = undefined) => {
    let pros =
      localStorage.getItem("products") !== ""
        ? JSON.parse(localStorage.getItem("products"))
        : [];
    if (pros.length === 0) {
      item["count"] = item.count;
      pros.push(item);
    } else {
      const index = pros.findIndex((v) => v.id === item.id);
      if (action === "delete") {
        pros = pros.filter((el) => el.id !== item.id);

        setSaleNum(SaleNum + 1)
      } else if (index !== -1) {
        pros[index].count = item.count;
      } else {
        pros.push({...item, count: item.count});
      }
    }

    localStorage.setItem("products", JSON.stringify(pros));
    setSaleNum(SaleNum + 1)
  };
  const numHandler = (data, id) => {

    const itemIndex = shopItems.findIndex((item) => item.id === id);

    if (itemIndex !== -1) {
      // Create a copy of the shopList to avoid mutating state directly
      const updatedShopList = [...shopItems];

      let tp
      if (updatedShopList[itemIndex].type === 1) {
        tp = 1
      } else {
        tp = +updatedShopList[itemIndex].defultValue
      }
      // Update the count based on the action ("up" or "down")
      if (data === "up" && +updatedShopList[itemIndex].count < +updatedShopList[itemIndex].inventory) {
        updatedShopList[itemIndex].count = +updatedShopList[itemIndex].count + tp;
        calculate(updatedShopList);
      } else if (data === "down" && updatedShopList[itemIndex].count > tp) {
        updatedShopList[itemIndex].count -= tp;
        calculate(updatedShopList);
      }

      setShopItems(updatedShopList);
      handleAddToCart(shopItems[itemIndex]);
    }
  };

  const goBasket = () => {
    const localData = localStorage.getItem("products") !== ""
      ? JSON.parse(localStorage.getItem("products"))
      : [];

    if (localData.length > 0) {
      let products = []
      let productsCount = []
      localData.forEach((v) => {
        products.push({id: v.id})
        productsCount.push({id: v.id, count: v.count})
      })

      axios.post(`${prefixUrl()}/cart/productReview.php`, {product: products})
        .then((response) => {
          if (response.data.status) {

            response.data.output.forEach((v) => {
              productsCount.forEach((q) => {
                if (v.id === q.id) {
                  v.count = q.count
                }
              })
            })
            localStorage.setItem("products", JSON.stringify(response.data.output))
            props.onShow();
            navigateTo("/Basket");
          }
        });
    } else {
      props.onShow();
    }
  }

  try {
    return (
      <div className="shopbagwidget">
        <div className="head-widget">
          <span>{shopItems.length}</span>
          <a href onClick={goBasket}>
            مشاهده سبد خرید
          </a>
        </div>
        <div className="widget-content">
          {shopItems?.map((item) => (
            <div className="bag-widget-item">
              <div className="widget-item-img">
                <img src={item?.images[0]?.url} alt=""/>
              </div>
              <div className="widget-item-content">
                <div className="widget-item-title">
                  {item.title}
                  <img
                    src={close}
                    alt=""
                    onClick={() => handleAddToCart(item, "delete")}
                  />
                </div>
                <div className="widget-item-details">
                  <div className="widget-add-item">
                    <div className="box-counter">
                      <button
                        className="icon-box"
                        id="up"
                        onClick={() => numHandler("up", item.id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="10"
                          viewBox="0 0 10 10"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_1128_20332)">
                            <path
                              d="M9 5.75H1C0.59 5.75 0.25 5.41 0.25 5C0.25 4.59 0.59 4.25 1 4.25H9C9.41 4.25 9.75 4.59 9.75 5C9.75 5.41 9.41 5.75 9 5.75Z"
                              fill="#40B2AA"
                            />
                            <path
                              d="M5 9.75C4.59 9.75 4.25 9.41 4.25 9V1C4.25 0.59 4.59 0.25 5 0.25C5.41 0.25 5.75 0.59 5.75 1V9C5.75 9.41 5.41 9.75 5 9.75Z"
                              fill="#40B2AA"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1128_20332">
                              <rect width="10" height="10" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </button>

                      <input
                        value={item?.type === 1 ? item?.count : item?.count.toFixed(1)}
                        readOnly
                      />

                      <button
                        className="icon-box"
                        id="low"
                        style={{marginBottom: "5px"}}
                        onClick={() => numHandler("down", item.id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="2"
                          viewBox="0 0 10 2"
                          fill="none"
                        >
                          <path
                            d="M9 1.75H1C0.59 1.75 0.25 1.41 0.25 1C0.25 0.59 0.59 0.25 1 0.25H9C9.41 0.25 9.75 0.59 9.75 1C9.75 1.41 9.41 1.75 9 1.75Z"
                            fill="#40B2AA"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="widget-item-price">
                    {formatToPersianAddComma(Math.floor((item.mainPrice - item.offerPrice) * item.count))} ریال
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="widget-bottom">
          <div className="widget-total-price">
            <span className="widget-price-title">مبلغ قابل پرداخت</span>
            <span className="widet-price-value">
            {formatToPersianAddComma(Math.floor(+mainPrice))} ریال
          </span>
          </div>
          <button className="final-submit bg-brown">
            <button onClick={goBasket}>ثبت سفارش</button>
          </button>
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ShopWidget;
